var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FFF8ED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_7035)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_7035",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.332 8H7.33203V32H31.332V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_654_7035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.332 29.25H14.332C10.682 29.25 8.58203 27.15 8.58203 23.5V16.5C8.58203 12.85 10.682 10.75 14.332 10.75H24.332C27.982 10.75 30.082 12.85 30.082 16.5V23.5C30.082 27.15 27.982 29.25 24.332 29.25ZM14.332 12.25C11.472 12.25 10.082 13.64 10.082 16.5V23.5C10.082 26.36 11.472 27.75 14.332 27.75H24.332C27.192 27.75 28.582 26.36 28.582 23.5V16.5C28.582 13.64 27.192 12.25 24.332 12.25H14.332Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3309 20.87C18.4909 20.87 17.6409 20.61 16.9908 20.08L13.8608 17.58C13.5408 17.32 13.4808 16.85 13.7408 16.53C14.0008 16.21 14.4708 16.15 14.7908 16.41L17.9209 18.91C18.6809 19.52 19.9709 19.52 20.7309 18.91L23.8609 16.41C24.1809 16.15 24.6609 16.2 24.9109 16.53C25.1709 16.85 25.1209 17.33 24.7909 17.58L21.6609 20.08C21.0209 20.61 20.1709 20.87 19.3309 20.87Z",
    fill: "#FFB600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_7035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.5d1045ae40bc377fae8729e75c909592.svg";
export { ForwardRef as ReactComponent };